const ASYNC_FETCH = 'ASYNC_FETCH';
const ASYNC_FETCH_SUCCESS = 'ASYNC_FETCH_SUCCESS';
const ERR_OCCURED = 'ERR_OCCURED';
const INVOKE_TAGGING = 'INVOKE_TAGGING';
const TAGGING_SUCCESS = 'TAGGING_SUCCESS';
const READDL_SUCCESS = 'READDL_SUCCESS;';
export const ADOBE_OVERRIDES = { SKIP_PAGEVIEW: 'SKIP_PAGEVIEW' };
export const ADD_ADOBE_EVENT = 'ADD_ADOBE_EVENT';
export const CLEAR_ADOBE_QUEUE = ' CLEAR_ADOBE_QUEUE';
export { ASYNC_FETCH, ASYNC_FETCH_SUCCESS, ERR_OCCURED, INVOKE_TAGGING, TAGGING_SUCCESS, READDL_SUCCESS };
